import { createFileRoute } from '@tanstack/react-router'
import ResetPassword from 'features/Auth/ResetPassword/ResetPassword.component'

export const Route = createFileRoute('/(auth)/_auth/reset-password')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ResetPassword />
}
